<template>
    <div>
        <StepHeader
            :subtitle="subtitle"
            :description="description"
        />
        <StepBtnGroup
            class="mt-4 step-group options"
            :fields="fields"
            :selectedValue="selectedOption"
            :orientation="'row'"
            layout="'card'"
            @select-value="selectOption"
        />
        <DisclaimerPanel
            v-show="isMentionActive"
            @set-color="pickColor"
            @set-text="setDisclaimerText"
            @set-fontsize="setFontsize"
            :selectedValues="{
                'text': disclaimerText,
                'color': disclaimerColor,
                'fontsize': disclaimerFontsize
            }"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepBtnGroup from '@/components/myHabiteoStudio/steps/components/StepBtnGroup';
    import DisclaimerPanel from '@/components/myHabiteoStudio/steps/components/DisclaimerPanel';

    export default {
        name: 'StepOptions',
        components: {
            DisclaimerPanel,
            StepHeader,
            StepBtnGroup
        },
        props: {
            subtitle: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            forms: {
                type: Array,
                required: true
            },
            selectedOption: {
                type: Boolean,
                required: false
            }
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable'
            ]),
            fields() {
                return this.$props.forms[0].inputs[0].fields;
            },
            isMentionActive() {
                return this.$props.forms[0].inputs[0].value; 
            },
            disclaimerColor() {
                return this.$props.forms[0].inputs[0].color ? this.$props.forms[0].inputs[0].color : null;
            },
            disclaimerFontsize() {
                return this.$props.forms[0].inputs[0].fontsize ? this.$props.forms[0].inputs[0].fontsize : null;
            },
            disclaimerText() {
                return this.$props.forms[0].inputs[0].text ? this.$props.forms[0].inputs[0].text : null;
            },
            disclaimerUserSettings() {
                return this.isLocalstorageAvailable ? (localStorage.getItem('myHabiteo-studio-disclaimer') ? JSON.parse(localStorage.getItem('myHabiteo-studio-disclaimer')) : null) : null;
            }
        },
        created() {
            // Default form values
            if (this.disclaimerUserSettings && this.$props.forms[0].inputs[0].text === undefined) {
                this.$props.forms[0].inputs[0].text = this.disclaimerUserSettings.text;
                this.$props.forms[0].inputs[0].color = this.disclaimerUserSettings.color;
                this.$props.forms[0].inputs[0].fontsize = this.disclaimerUserSettings.fontsize;
            } else {
                this.$props.forms[0].inputs[0].text = this.$props.forms[0].inputs[0].text || this.$t('habiteoStudio.templateDisclaimer');
                this.$props.forms[0].inputs[0].color = this.$props.forms[0].inputs[0].color || '#000000';
                this.$props.forms[0].inputs[0].fontsize = this.$props.forms[0].inputs[0].fontsize || 12;
            }
        },
        methods: {
            selectOption(option) {
                this.$props.forms[0].inputs[0].value = option;
            },
            pickColor(color) {
                this.$props.forms[0].inputs[0].color = color;
                this.$emit('update-disclaimer');
            },
            setDisclaimerText(text) {
                this.$props.forms[0].inputs[0].text = text;
                this.$emit('update-disclaimer');
            },
            setFontsize(fontsize) {
                this.$props.forms[0].inputs[0].fontsize = fontsize;
                this.$emit('update-disclaimer');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepOptions.vue